var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuizAchieved(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 148.21 134.36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        opacity: .5;\n      }\n\n      .cls-3 {\n        fill: url(#New_Gradient_Swatch_copy_5-4);\n      }\n\n      .cls-3, .cls-4, .cls-5 {\n        mix-blend-mode: overlay;\n      }\n\n      .cls-4 {\n        fill: url(#New_Gradient_Swatch_copy_5-3);\n      }\n\n      .cls-6 {\n        isolation: isolate;\n      }\n\n      .cls-5 {\n        fill: url(#New_Gradient_Swatch_copy_5-2);\n      }\n\n      .cls-7 {\n        opacity: .75;\n      }\n\n      .cls-8 {\n        fill: none;\n      }\n\n      .cls-9 {\n        fill: url(#New_Gradient_Swatch_copy_5);\n        stroke: url(#linear-gradient);\n        stroke-miterlimit: 10;\n        stroke-width: 10px;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_5",
    "data-name": "New Gradient Swatch copy 5",
    x1: 5,
    y1: 67.18,
    x2: 143.21,
    y2: 67.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fedb4a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#feb11a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0,
    y1: 67.18,
    x2: 148.21,
    y2: 67.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#feb11a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fedb4a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_5-2",
    "data-name": "New Gradient Swatch copy 5",
    x1: 5,
    x2: 143.21,
    xlinkHref: "#New_Gradient_Swatch_copy_5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_5-3",
    "data-name": "New Gradient Swatch copy 5",
    x1: 13.97,
    y1: 68.06,
    x2: 143.21,
    y2: 68.06,
    xlinkHref: "#New_Gradient_Swatch_copy_5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_copy_5-4",
    "data-name": "New Gradient Swatch copy 5",
    x1: 34.72,
    y1: 85.6,
    x2: 143.21,
    y2: 85.6,
    xlinkHref: "#New_Gradient_Swatch_copy_5"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_4",
    "data-name": "Layer 4"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m99.95,5h-51.69c-6.22,0-11.97,3.32-15.08,8.71L7.33,58.47c-3.11,5.39-3.11,12.03,0,17.42l25.85,44.77c3.11,5.39,8.86,8.71,15.08,8.71h51.69c6.22,0,11.97-3.32,15.08-8.71l25.85-44.77c3.11-5.39,3.11-12.03,0-17.42l-25.85-44.77c-3.11-5.39-8.86-8.71-15.08-8.71Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m99.95,129.37h-51.69c-5.31,0-10.29-2.42-13.54-6.49-.58-.69-1.09-1.43-1.54-2.22l-19.21-33.27-6.64-11.5c-3.11-5.38-3.11-12.02,0-17.41L33.18,13.71c3.11-5.39,8.86-8.71,15.08-8.71h51.69c2.68,0,5.28.62,7.61,1.76,3.08,1.49,5.7,3.89,7.47,6.95l16.24,28.13,9.61,16.64c3.11,5.39,3.11,12.03,0,17.41l-25.85,44.77c-3.11,5.39-8.86,8.71-15.08,8.71Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m140.88,75.89l-25.85,44.77c-3.11,5.39-8.86,8.71-15.08,8.71h-51.69c-5.31,0-10.29-2.42-13.54-6.49-.58-.69-1.09-1.43-1.54-2.22l-19.21-33.27C51.58,64.48,83.82,38.25,107.56,6.76c3.08,1.49,5.7,3.89,7.47,6.95l16.24,28.13,9.61,16.64c3.11,5.39,3.11,12.03,0,17.41Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m99.95,129.37h-51.69c-5.31,0-10.29-2.42-13.54-6.49,40.54-21.41,73.73-47.76,96.55-81.04l9.61,16.64c3.11,5.39,3.11,12.03,0,17.41l-25.85,44.77c-3.11,5.39-8.86,8.71-15.08,8.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m140.88,75.89l-25.85,44.77c-3.11,5.39-8.86,8.71-15.08,8.71h-51.69c-5.31,0-10.29-2.42-13.54-6.49-.58-.69-1.09-1.43-1.54-2.22l-19.21-33.27-6.64-11.5c-3.11-5.38-3.11-12.02,0-17.41L33.18,13.71c3.11-5.39,8.86-8.71,15.08-8.71h51.69c2.68,0,5.28.62,7.61,1.76,3.08,1.49,5.7,3.89,7.47,6.95l16.24,28.13,9.61,16.64c3.11,5.39,3.11,12.03,0,17.41Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m50.35,90.46c-.31-.24-.61-.49-.9-.73s-.28-.69.01-.91c.95-.72,1.7-1.58,2.25-2.58.67-1.2,1.1-2.59,1.3-4.15.2-1.56.2-3.29.02-5.18l-1.48-14.98c-.27-2.79-.89-5.12-1.85-7-.96-1.88-2.37-3.26-4.25-4.13-1.88-.87-4.34-1.15-7.4-.85-3.02.3-5.36,1.06-7.01,2.27-1.66,1.22-2.77,2.84-3.34,4.88-.57,2.03-.72,4.44-.44,7.23l1.48,14.98c.27,2.75.89,5.09,1.85,7,.96,1.92,2.37,3.32,4.23,4.21,1.86.89,4.3,1.18,7.32.89.17-.02.32-.03.45-.04.13-.01.26-.04.39-.09.8.99,1.76,1.95,2.87,2.86,1.11.91,2.22,1.69,3.32,2.34.81.47,1.52.84,2.15,1.11.34.14.72-.05.81-.41l1.08-4.31c.07-.28-.08-.57-.34-.69-.34-.16-.68-.35-1.02-.58-.5-.34-1.01-.7-1.52-1.11Zm-6.18-8.16c-.06.74-.28,1.37-.67,1.88-.39.51-1.04.81-1.97.9-.93.09-1.62-.07-2.08-.5-.46-.42-.79-.99-.97-1.71-.19-.72-.32-1.46-.39-2.22l-1.91-19.41c-.08-.8-.1-1.56-.05-2.28.05-.72.25-1.34.62-1.85.37-.51,1.02-.8,1.95-.9.93-.09,1.63.07,2.11.5.48.42.82.98,1.02,1.68.2.7.34,1.45.42,2.24l1.91,19.41c.08.76.08,1.52.02,2.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m78.74,46.48l-7.67.76c-.33.03-.57.32-.54.65l2.82,28.57c.08.83.11,1.67.07,2.51-.03.84-.24,1.55-.62,2.12-.38.57-1.05.91-2.01,1-.93.09-1.64-.11-2.14-.59-.5-.49-.86-1.14-1.07-1.95-.21-.82-.36-1.64-.44-2.47l-2.82-28.57c-.03-.33-.32-.57-.65-.54l-7.62.75c-.33.03-.57.32-.54.65l2.68,27.23c.28,2.82.86,5.17,1.75,7.04.89,1.87,2.25,3.23,4.09,4.07,1.84.84,4.31,1.11,7.39.8s5.44-1.05,7.07-2.23c1.63-1.18,2.7-2.78,3.22-4.79.52-2.01.64-4.43.37-7.25l-2.68-27.23c-.03-.33-.32-.57-.65-.54Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 87.02,
    y: 45.32,
    width: 8.95,
    height: 40.51,
    rx: 0.6,
    ry: 0.6,
    transform: "translate(-5.99 9.29) rotate(-5.63)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m119.94,77.04l-8.68.86c-.41.04-.73-.33-.64-.73l6.91-29.34c.02-.06.02-.13.01-.2l-.43-4.33c-.03-.33-.32-.57-.65-.54l-16.98,1.67c-.33.03-.57.32-.54.65l.48,4.83c.03.33.32.57.65.54l7.98-.79c.41-.04.73.33.64.73l-6.79,28.98c-.01.06-.02.13-.01.19l.46,4.68c.03.33.32.57.65.54l17.53-1.73c.33-.03.57-.32.54-.65l-.48-4.83c-.03-.33-.32-.57-.65-.54Z"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuizAchieved);
export default __webpack_public_path__ + "static/media/quiz-achieved.3e355c1e7e1b99de05ac360e07b32c9a.svg";
export { ForwardRef as ReactComponent };